import type { EntitiesStore } from 'entities/EntitiesExport'
import { ruleLandingMobile } from 'app/shared/layouts/GlobalAccessLayout/config/ruleLandingMobile'
import { ruleSubscription } from 'app/shared/layouts/GlobalAccessLayout/config/ruleSubscription'
import { ruleAuth } from 'app/shared/layouts/GlobalAccessLayout/config/ruleAuth'
import { ruleNumber } from 'app/shared/layouts/GlobalAccessLayout/config/ruleNumber'
import { ruleAgency } from 'app/shared/layouts/GlobalAccessLayout/config/ruleAgency'
import { ruleGuest } from 'app/shared/layouts/GlobalAccessLayout/config/ruleGuest'

type INextResult = {
  path: string
  query?: string
}

type INextArg = INextResult | string
type INextCallBack = (data?: INextArg) => INextResult | undefined

export const configNext: INextCallBack = (data) => {
  if (!data) return

  if (typeof data === 'string') {
    return {
      path: data,
    }
  }

  return data
}

export type IConfigResult = {
  path: string
  query: URLSearchParams
}

export type IConfigGlobalAccess = (
  entities: EntitiesStore,
  to: IConfigResult,
  next: INextCallBack
) => INextResult | undefined

export const configGlobalAccess: IConfigGlobalAccess[] = [
  ruleGuest,
  ruleLandingMobile,
  ruleSubscription,
  ruleAuth,
  ruleNumber,
  ruleAgency,
]
